import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import AppUsageList from "../../../assets/components/reports/AppUsageList";

class AppUsageListReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>App Usage List</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <AppUsageList />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default AppUsageListReport;
